/**
 * 링크 자료를 새 탭으로 여는 두 단계.
 *
 * 새 탭은 클릭 순간에만 열 수 있다 — 서버 응답을 기다린 뒤 window.open 을 부르면 브라우저가
 * 팝업으로 막는다. 그래서 클릭에서 빈 탭을 먼저 열고(openBlankTab), 주소를 받으면 그 탭을
 * 보낸다(openAssetLink). 주소는 로그인한 사람에게 서버가 그때 건넨다 — 화면에 미리 싣지 않는다.
 *
 * 별도 모듈인 이유 — jsdom 은 창·내비게이션을 구현하지 않아, 테스트가 이 심(seam)을
 * jest.mock 으로 갈아끼운다 (start-file-download 와 같은 이유).
 */

const HTTPS_PREFIX = 'https://';

/** 팝업이 막히면 null — openAssetLink 가 같은 탭으로 연다. */
export function openBlankTab(): Window | null {
  const tab = window.open('', '_blank');
  if (tab !== null) {
    // noopener 로 열면 참조가 null 이라 나중에 주소를 넣을 수 없다 — 대신 연 직후 연결을 끊어
    //   열린 쪽 페이지가 window.opener 로 우리 페이지를 바꾸지 못하게 한다.
    tab.opener = null;
  }
  return tab;
}

/**
 * 열었으면 true. 못 열면 미리 연 빈 탭을 닫고 false — 던지지 않는다: 호출자는 react-query 의
 * 성공 콜백이고, 거기서 던진 오류는 삼켜져 화면에 아무것도 뜨지 않는다.
 */
export function openAssetLink(url: string, tab: Window | null): boolean {
  // 서버·DB 가 https 만 받지만, 사용자를 주소로 보내는 마지막 자리라 한 번 더 본다
  if (!url.startsWith(HTTPS_PREFIX)) {
    tab?.close();
    return false;
  }
  try {
    if (tab !== null && !tab.closed) {
      tab.location.href = url;
      return true;
    }
    // 탭이 없다 — 팝업이 막혔거나, 로그인 복귀 후 자동 재개처럼 클릭 없이 불렸다. 같은 탭에서 연다
    window.location.assign(url);
    return true;
  } catch {
    tab?.close();
    return false;
  }
}
